const header = document.querySelector('.header')
const toggle = document.querySelector('.header-compact-toggle')
const nav = document.getElementById('nav')

const THRESHOLD = 100
const desktop = matchMedia('(min-width: 1440px)')

let lastY = window.scrollY
let ticking = false

const setCompact = (on) => {
  const changed = header.classList.contains('menu-is-compact') !== on
  header.classList.toggle('menu-is-compact', on)
  if (toggle) toggle.setAttribute('aria-expanded', String(!on))
  if (nav) nav.inert = on // keep the off-screen nav out of tab order / AT
  // Entering compact must close any open dropdown, which is positioned against
  // .header-bar and otherwise lingers behind the compact button. Leaving compact
  // must restore the section that was active on page load (its second-level nav
  // is driven by the same class the close wiped). Fire both ways so the nav can
  // react to each transition.
  if (changed) window.dispatchEvent(new CustomEvent('header:compact', { detail: { compact: on } }))
}

const update = () => {
  ticking = false
  const y = window.scrollY
  if (!desktop.matches) {
    setCompact(false)
    lastY = y
    return
  }
  if (y <= THRESHOLD) {
    setCompact(false)
  } else if (y > lastY) {
    setCompact(true) // scrolling down past the threshold
  }
  lastY = y
}

const onScroll = () => {
  if (ticking) return
  ticking = true
  requestAnimationFrame(update)
}

if (header) {
  window.addEventListener('scroll', onScroll, { passive: true })
  desktop.addEventListener('change', update)

  if (toggle) {
    toggle.addEventListener('click', () => {
      setCompact(false)
      lastY = window.scrollY
    })
  }

  update()
}
